import { defineMessages } from 'react-intl';

const messages = defineMessages({
  publishedAvailability: {
    id: 'notable-event.publishedAvailability',
    defaultMessage: '{hsName} {publishedBold} their Rep Visits availability',
  },
  publishedFair: {
    id: 'notable-event.publishedFair',
    defaultMessage: '{hsName} {publishedBold} a new College Fair',
  },
  published: {
    id: 'notable-event.published',
    defaultMessage: 'published',
  },
  seeAvailability: {
    id: 'notable-event.seeAvailability',
    defaultMessage: 'See availability',
  },
});

export default messages;
